module.exports = __webpack_public_path__ + "media/images/icon_online-87bc3830.svg";